<template>
	<div class="main-wrap">
		<main-visual />
		<contents1 />
		<contents2 />
		<contents3 />
		<contents4 />
		<contents5 />
		<contents6 />
		<contents7 />
		<contents8 />
		<notice />
		<contents9 />
		<contents10 />
		<contents11 />
	</div>
</template>

<script>
import mainVisual from '@/components/contents/main/MainVisual'
import contents1 from '@/components/contents/main/Contents1'
import contents2 from '@/components/contents/main/Contents2'
import contents3 from '@/components/contents/main/Contents3'
import contents4 from '@/components/contents/main/Contents4'
import contents5 from '@/components/contents/main/Contents5'
import contents6 from '@/components/contents/main/Contents6'
import contents7 from '@/components/contents/main/Contents7'
import contents8 from '@/components/contents/main/Contents8'
import contents9 from '@/components/contents/main/Contents9'
import contents10 from '@/components/contents/main/Contents10'
import contents11 from '@/components/contents/main/Contents11'
import notice from '@/components/contents/main/Notice'
export default {
	components: {
		mainVisual,
		contents1,
		contents2,
		contents3,
		contents4,
		contents5,
		contents6,
		contents7,
		contents8,
		contents9,
		contents10,
		contents11,
		notice,
	},
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/Main.vue